import scheduler from "@homer.core/scheduler";
import Script from "@homer.core/script";
import whenImages from "@homer.core/when.images";
import hash from "@homer.utility/hash";

const node = document.head.querySelector('meta[itemprop="turnstile"]');
const sitekey = node ? node.getAttribute("content") : null;
const callback = `ts${hash(new Date().toISOString())}`;
let turnstile;

if (!sitekey) {
    throw new Error("Turnstile is not configured");
}

scheduler.yield.low(whenImages).then(() => {
    setTimeout(() => {
        void obtainTurnstile();
    }, 5000);
});

const obtainTurnstile = () => {
    if (turnstile) {
        return turnstile;
    }

    const ready = new Promise((resolve, reject) => {
        globalThis[callback] = () => {
            const turnstile = globalThis.turnstile;

            if (turnstile) {
                resolve(turnstile);
            } else {
                reject(new Error(`globalThis.turnstile is ${turnstile}`));
            }
        };
    });

    return (turnstile = new Script(`//challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=${callback}`, {
        id: "turnstile",
        crossorigin: true,
        resolver: (resolve, reject) => {
            ready.then(resolve, reject);
        },
    })
        .finally(() => {
            delete globalThis[callback];
        })
        .catch((error) => {
            turnstile = null;

            throw error;
        }));
};

const removeWidget = (turnstile, widget) => {
    if (widget !== undefined) {
        try {
            turnstile.remove(widget);
        } catch (error) {
            console.warn("Failed to remove expired widget:", error);
        }
    }
};

class Turnstile {
    get() {
        return obtainTurnstile().then((turnstile) => {
            return new Promise((resolve, reject) => {
                const widget = turnstile.render(document.body, {
                    sitekey: sitekey,
                    theme: "light",
                    retry: "never",
                    callback: (...parameter) => {
                        clearTimeout(timeout);
                        removeWidget(turnstile, widget);
                        resolve(...parameter);
                    },
                    "error-callback": (...parameter) => {
                        clearTimeout(timeout);
                        removeWidget(turnstile, widget);
                        reject(`Turnstile error: ${parameter[0]}`);
                    },
                    "expired-callback": () => {
                        clearTimeout(timeout);
                        removeWidget(turnstile, widget);
                        reject("Turnstile token expired");
                    },
                    "timeout-callback": () => {
                        clearTimeout(timeout);
                        removeWidget(turnstile, widget);
                        reject("Turnstile interactive challenge timed out");
                    },
                    "unsupported-callback": () => {
                        clearTimeout(timeout);
                        removeWidget(turnstile, widget);
                        reject("Turnstile does not support this client");
                    },
                });

                // short lifetime because turnstile is rendered invisibly
                const timeout = setTimeout(() => {
                    removeWidget(turnstile, widget);
                    reject("Turnstile challenge did not complete within 20 seconds (invisible render timeout)");
                }, 20000);
            });
        });
    }
}

export default new Turnstile();
